__turbopack_context__.v({
  "className": "noto_sans_ethiopic_db7d835c-module__9fdAMG__className",
});
